import script from "./departmentsAppearance.vue?vue&type=script&setup=true&lang=ts"
export * from "./departmentsAppearance.vue?vue&type=script&setup=true&lang=ts"

import "./departmentsAppearance.vue?vue&type=style&index=0&id=89b5ee58&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b5ee58"]])

export default __exports__